import { gql } from "@apollo/client";

export const GET_GOOGLE_MAPS_RUSH_HOURS = gql`
  query GetGoogleMapsRushHours {
    getGoogleMapsRushHours {
      id
      rules {
        date
        timeFrom
        timeTo
        marginMinutes
      }
      createdAt
      updatedAt
    }
  }
`;
